var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasActivity
    ? _c(
        "div",
        {
          class: ["go-widget-sub-wrap", { "fade-chat": _vm.shouldDisableChat }],
        },
        [
          _c(
            "div",
            {
              class: [
                "go-widget-sub-chat",
                { "disactived-chat": _vm.shouldDisableChat },
              ],
            },
            [
              _c(
                "div",
                { staticClass: "go-widget-header" },
                [
                  _vm.$route.name === "Home"
                    ? _c(
                        "a",
                        {
                          staticClass: "go-tooltip-area",
                          attrs: { "data-toggle": "tooltip", title: "Back" },
                          on: { click: _vm.backToHome },
                        },
                        [
                          _c("i", {
                            staticClass: "go-icon-28 go-icon-arrow-left",
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isEditing
                    ? _c("h2", { on: { dblclick: _vm.editTitle } }, [
                        _vm._v(
                          "\n        " + _vm._s(_vm.titleChat) + "\n      "
                        ),
                      ])
                    : _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.titleChat,
                            expression: "titleChat",
                          },
                          { name: "autotrim", rawName: "v-autotrim" },
                        ],
                        ref: "titleInput",
                        staticClass: "edit-input",
                        staticStyle: { width: "100%" },
                        domProps: { value: _vm.titleChat },
                        on: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.saveTitle()
                          },
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.titleChat = $event.target.value
                          },
                        },
                      }),
                  _vm._v(" "),
                  _vm.isEditing
                    ? [
                        _c(
                          "button",
                          {
                            staticClass: "action-button",
                            class: {
                              whiteTheme: _vm.getColorTheme === "light",
                              blackTheme: _vm.getColorTheme === "dark",
                            },
                            on: { click: _vm.saveTitle },
                          },
                          [_vm._v("\n          ✔\n        ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "action-button",
                            class: {
                              whiteTheme: _vm.getColorTheme === "light",
                              blackTheme: _vm.getColorTheme === "dark",
                            },
                            on: { click: _vm.cancelEdit },
                          },
                          [_vm._v("\n          ✖\n        ")]
                        ),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isEditing && !_vm.waitingResponse
                    ? _c(
                        "button",
                        {
                          staticClass: "go-tooltip-area",
                          attrs: {
                            "data-toggle": "tooltip",
                            title: _vm.$t("ask.editTitle"),
                          },
                          on: { click: _vm.editTitle },
                        },
                        [_c("i", { staticClass: "go-icon-20 go-icon-edit-2" })]
                      )
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: [
                    "go-widget-body ",
                    _vm.isShowDetailActivity ? "go-chat-activity" : "",
                  ],
                },
                [
                  _c(
                    "vue-custom-scrollbar",
                    {
                      ref: "go-list-inner",
                      staticClass:
                        "go-widget-contents go-list-inner overflow-y-scroll",
                      attrs: {
                        id: "go-list-inner-chat",
                        settings: {
                          suppressScrollX: true,
                          wheelPropagation: true,
                          wheelSpeed: 0.5,
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "go-list-wrap" }, [
                        _c(
                          "ul",
                          { ref: "go-chat-list", staticClass: "go-chat-list" },
                          [
                            _vm._l(
                              _vm.conversation.sentences,
                              function (sentence, indexSentence) {
                                return _c(
                                  "li",
                                  {
                                    key: indexSentence,
                                    staticClass: "go-chat-item-message",
                                  },
                                  [
                                    sentence.role === _vm.CONVERSATION_ROLE.USER
                                      ? _c(
                                          "div",
                                          { staticClass: "go-user-message" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "go-chat-message-area",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "go-chat-message-balloon",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "go-block-body",
                                                      },
                                                      [
                                                        _c("p", {
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              sentence.content
                                                            ),
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : sentence.role !==
                                        _vm.CONVERSATION_ROLE.DATE
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "go-response-message",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "go-chat-message-area",
                                              },
                                              [
                                                (!sentence.llmContent ||
                                                  sentence.llmContent.length ==
                                                    0 ||
                                                  !sentence.content) &&
                                                !sentence.resourceIds
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "go-chat-message-balloon",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "go-chat-message-alert",
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "go-icon-24 go-icon-alert-circle",
                                                            }),
                                                            _vm._v(" "),
                                                            _c("p", {
                                                              domProps: {
                                                                textContent:
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "ask.errorAnswer"
                                                                    )
                                                                  ),
                                                              },
                                                            }),
                                                            _vm._v(" "),
                                                            _c(
                                                              "button",
                                                              {
                                                                staticClass:
                                                                  "btn go-btn-default go-btn-sm",
                                                                attrs: {
                                                                  type: "button",
                                                                },
                                                                on: {
                                                                  click:
                                                                    _vm.reloadAskAction,
                                                                },
                                                              },
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "go-icon-18 go-icon-reload",
                                                                }),
                                                                _vm._v(
                                                                  "\n                        " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "ask.reloadAnswer"
                                                                      )
                                                                    ) +
                                                                    "\n                      "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                sentence.llmContent &&
                                                sentence.llmContent.length > 0
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "go-chat-message-balloon",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "go-block-body",
                                                            attrs: {
                                                              id:
                                                                "go-block-body_" +
                                                                indexSentence,
                                                            },
                                                          },
                                                          [
                                                            _vm._l(
                                                              sentence.llmContent,
                                                              function (
                                                                item,
                                                                index
                                                              ) {
                                                                return _c(
                                                                  "div",
                                                                  {
                                                                    key: index,
                                                                  },
                                                                  [
                                                                    item.model ==
                                                                      "goover" &&
                                                                    _vm
                                                                      .conversation
                                                                      .sentences &&
                                                                    indexSentence ==
                                                                      _vm
                                                                        .conversation
                                                                        .sentences
                                                                        .length -
                                                                        1 &&
                                                                    _vm.waitingResponse
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "go-chat-roader",
                                                                            staticStyle:
                                                                              {
                                                                                "margin-top":
                                                                                  "2rem",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "go-chat-roader-area",
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "go-block-body",
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "div",
                                                                                      {
                                                                                        staticClass:
                                                                                          "go-chat-message-roader",
                                                                                      }
                                                                                    ),
                                                                                    _vm._v(
                                                                                      " "
                                                                                    ),
                                                                                    _c(
                                                                                      "strong",
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            _vm.$t(
                                                                                              "ask.roader.text1"
                                                                                            )
                                                                                          )
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "go-block-footer",
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "ul",
                                                                                      {
                                                                                        staticClass:
                                                                                          "go-info-list",
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "li",
                                                                                          {
                                                                                            staticClass:
                                                                                              "go-list-item",
                                                                                          },
                                                                                          [
                                                                                            _vm._v(
                                                                                              _vm._s(
                                                                                                _vm.$t(
                                                                                                  "ask.roader.text2"
                                                                                                )
                                                                                              )
                                                                                            ),
                                                                                          ]
                                                                                        ),
                                                                                        _vm._v(
                                                                                          " "
                                                                                        ),
                                                                                        _c(
                                                                                          "li",
                                                                                          {
                                                                                            staticClass:
                                                                                              "go-list-item",
                                                                                          },
                                                                                          [
                                                                                            _vm._v(
                                                                                              _vm._s(
                                                                                                _vm.$t(
                                                                                                  "ask.roader.text3"
                                                                                                )
                                                                                              )
                                                                                            ),
                                                                                          ]
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    item.model
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            key: index,
                                                                            class:
                                                                              [
                                                                                item.model ==
                                                                                "goover"
                                                                                  ? "llm-model-goover"
                                                                                  : "llm-model-etc",
                                                                              ],
                                                                          },
                                                                          [
                                                                            item.model ==
                                                                            "goover"
                                                                              ? _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "llm-model-title",
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "i",
                                                                                      {
                                                                                        staticClass:
                                                                                          "go-icon-goover-full",
                                                                                      }
                                                                                    ),
                                                                                    _vm._v(
                                                                                      " "
                                                                                    ),
                                                                                    _c(
                                                                                      "strong",
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            sentence.isDeepAnswer
                                                                                              ? _vm.$t(
                                                                                                  "cdHome.t8"
                                                                                                )
                                                                                              : _vm.$t(
                                                                                                  "cdHome.t6"
                                                                                                )
                                                                                          )
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                    _vm._v(
                                                                                      " "
                                                                                    ),
                                                                                    _c(
                                                                                      "small",
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            _vm.$t(
                                                                                              "ask.with"
                                                                                            )
                                                                                          ) +
                                                                                            " " +
                                                                                            _vm._s(
                                                                                              _vm.$t(
                                                                                                "cdHome.t12"
                                                                                              )
                                                                                            )
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ]
                                                                                )
                                                                              : _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "llm-model-title",
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "strong",
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            _vm.$t(
                                                                                              (
                                                                                                _vm.llmModels.find(
                                                                                                  function (
                                                                                                    llmModel
                                                                                                  ) {
                                                                                                    return (
                                                                                                      llmModel.value ==
                                                                                                      item.model
                                                                                                    )
                                                                                                  }
                                                                                                ) ||
                                                                                                {}
                                                                                              )
                                                                                                .text ||
                                                                                                "cdHome.t12"
                                                                                            )
                                                                                          )
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    _c("div", {
                                                                      key:
                                                                        "c_" +
                                                                        index,
                                                                      staticClass:
                                                                        "go-markdown-body",
                                                                      attrs: {
                                                                        id:
                                                                          item.model ==
                                                                          "goover"
                                                                            ? "content_" +
                                                                              indexSentence
                                                                            : "",
                                                                      },
                                                                      domProps:
                                                                        {
                                                                          innerHTML:
                                                                            _vm._s(
                                                                              _vm.convertMarkdown2Html(
                                                                                item.content
                                                                              )
                                                                            ),
                                                                        },
                                                                    }),
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            _vm._v(" "),
                                                            !_vm.waitingResponse &&
                                                            _vm.popoverDataList
                                                              ? _vm._l(
                                                                  _vm.popoverDataList,
                                                                  function (
                                                                    popoverItem
                                                                  ) {
                                                                    return _c(
                                                                      "b-popover",
                                                                      {
                                                                        key: popoverItem.idElement,
                                                                        attrs: {
                                                                          "custom-class":
                                                                            "go-popover-preview-doc",
                                                                          target:
                                                                            popoverItem.idElement,
                                                                          triggers:
                                                                            "hover",
                                                                          placement:
                                                                            "top",
                                                                        },
                                                                        scopedSlots:
                                                                          _vm._u(
                                                                            [
                                                                              popoverItem.description
                                                                                ? {
                                                                                    key: "title",
                                                                                    fn: function () {
                                                                                      return [
                                                                                        _c(
                                                                                          "div",
                                                                                          {
                                                                                            staticClass:
                                                                                              "go-preview-info",
                                                                                          },
                                                                                          [
                                                                                            popoverItem.channel
                                                                                              ? _c(
                                                                                                  "span",
                                                                                                  {
                                                                                                    staticClass:
                                                                                                      "go-channel",
                                                                                                  },
                                                                                                  [
                                                                                                    _vm._v(
                                                                                                      _vm._s(
                                                                                                        popoverItem.channel
                                                                                                      )
                                                                                                    ),
                                                                                                  ]
                                                                                                )
                                                                                              : _vm._e(),
                                                                                            _vm._v(
                                                                                              " "
                                                                                            ),
                                                                                            popoverItem.published_at
                                                                                              ? _c(
                                                                                                  "span",
                                                                                                  {
                                                                                                    staticClass:
                                                                                                      "go-datetime",
                                                                                                  },
                                                                                                  [
                                                                                                    _vm._v(
                                                                                                      _vm._s(
                                                                                                        popoverItem.published_at
                                                                                                      )
                                                                                                    ),
                                                                                                  ]
                                                                                                )
                                                                                              : _vm._e(),
                                                                                          ]
                                                                                        ),
                                                                                        _vm._v(
                                                                                          " "
                                                                                        ),
                                                                                        _c(
                                                                                          "div",
                                                                                          {
                                                                                            staticClass:
                                                                                              "go-preview-title",
                                                                                          },
                                                                                          [
                                                                                            _vm._v(
                                                                                              _vm._s(
                                                                                                popoverItem.title
                                                                                              )
                                                                                            ),
                                                                                          ]
                                                                                        ),
                                                                                      ]
                                                                                    },
                                                                                    proxy: true,
                                                                                  }
                                                                                : null,
                                                                            ],
                                                                            null,
                                                                            true
                                                                          ),
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        popoverItem.description
                                                                          ? [
                                                                              _c(
                                                                                "p",
                                                                                {
                                                                                  staticClass:
                                                                                    "go-preview-desc",
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      popoverItem.description
                                                                                    )
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          : [
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "go-preview-empy",
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "i",
                                                                                    {
                                                                                      staticClass:
                                                                                        "go-icon-32 go-icon-hidden",
                                                                                    }
                                                                                  ),
                                                                                  _vm._v(
                                                                                    " "
                                                                                  ),
                                                                                  _c(
                                                                                    "p",
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          _vm.$t(
                                                                                            "briefing.view-card.preview-empty.text1"
                                                                                          )
                                                                                        )
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                  _vm._v(
                                                                                    " "
                                                                                  ),
                                                                                  _c(
                                                                                    "small",
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          _vm.$t(
                                                                                            "briefing.view-card.preview-empty.text2"
                                                                                          )
                                                                                        )
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ],
                                                                      ],
                                                                      2
                                                                    )
                                                                  }
                                                                )
                                                              : _vm._e(),
                                                          ],
                                                          2
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "go-block-footer",
                                                          },
                                                          [
                                                            !(
                                                              (!sentence.llmContent ||
                                                                sentence
                                                                  .llmContent
                                                                  .length ==
                                                                  0 ||
                                                                !sentence.content) &&
                                                              !sentence.resourceIds
                                                            ) &&
                                                            !_vm.waitingResponse
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "go-chat-message-btns",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "button",
                                                                      {
                                                                        key: "go-btn-like"
                                                                          .concat(
                                                                            _vm.buttonLikeOrDisLikeKey ||
                                                                              ""
                                                                          )
                                                                          .concat(
                                                                            "_" +
                                                                              indexSentence
                                                                          ),
                                                                        staticClass:
                                                                          "btn go-btn-icon",
                                                                        class: [
                                                                          "btn go-btn-icon go-btn-like ",
                                                                          {
                                                                            active:
                                                                              sentence.like ===
                                                                              1,
                                                                          },
                                                                        ],
                                                                        attrs: {
                                                                          type: "button",
                                                                          "data-toggle":
                                                                            "button",
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.handleUserInteract(
                                                                                sentence,
                                                                                1,
                                                                                indexSentence,
                                                                                $event
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            directives:
                                                                              [
                                                                                {
                                                                                  name: "b-tooltip",
                                                                                  rawName:
                                                                                    "v-b-tooltip.hover",
                                                                                  value:
                                                                                    {
                                                                                      customClass:
                                                                                        "go-tooltip",
                                                                                    },
                                                                                  expression:
                                                                                    "{ customClass: 'go-tooltip' }",
                                                                                  modifiers:
                                                                                    {
                                                                                      hover: true,
                                                                                    },
                                                                                },
                                                                              ],
                                                                            staticClass:
                                                                              "go-tooltip-area",
                                                                            attrs:
                                                                              {
                                                                                "data-toggle":
                                                                                  "tooltip",
                                                                                "data-original-title":
                                                                                  "Like",
                                                                                title:
                                                                                  _vm.$t(
                                                                                    "ask.like"
                                                                                  ),
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "i",
                                                                              {
                                                                                staticClass:
                                                                                  "go-icon-20 go-icon-like",
                                                                              }
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "button",
                                                                      {
                                                                        key: "go-btn-dislike"
                                                                          .concat(
                                                                            _vm.buttonLikeOrDisLikeKey ||
                                                                              ""
                                                                          )
                                                                          .concat(
                                                                            "_" +
                                                                              indexSentence
                                                                          ),
                                                                        staticClass:
                                                                          "btn go-btn-icon",
                                                                        class: [
                                                                          "btn go-btn-icon go-btn-dislike ",
                                                                          {
                                                                            active:
                                                                              sentence.like ===
                                                                              -1,
                                                                          },
                                                                        ],
                                                                        attrs: {
                                                                          type: "button",
                                                                          "data-toggle":
                                                                            "button",
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.handleUserInteract(
                                                                                sentence,
                                                                                -1,
                                                                                indexSentence,
                                                                                $event
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            directives:
                                                                              [
                                                                                {
                                                                                  name: "b-tooltip",
                                                                                  rawName:
                                                                                    "v-b-tooltip.hover",
                                                                                  value:
                                                                                    {
                                                                                      customClass:
                                                                                        "go-tooltip",
                                                                                    },
                                                                                  expression:
                                                                                    "{ customClass: 'go-tooltip' }",
                                                                                  modifiers:
                                                                                    {
                                                                                      hover: true,
                                                                                    },
                                                                                },
                                                                              ],
                                                                            staticClass:
                                                                              "go-tooltip-area",
                                                                            attrs:
                                                                              {
                                                                                "data-toggle":
                                                                                  "tooltip",
                                                                                title:
                                                                                  _vm.$t(
                                                                                    "ask.dislike"
                                                                                  ),
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "i",
                                                                              {
                                                                                staticClass:
                                                                                  "go-icon-20 go-icon-dislike",
                                                                              }
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "button",
                                                                      {
                                                                        staticClass:
                                                                          "btn go-btn-icon",
                                                                        attrs: {
                                                                          type: "button",
                                                                          disabled:
                                                                            _vm.isCopied(
                                                                              indexSentence
                                                                            ),
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.copyText(
                                                                                indexSentence,
                                                                                sentence.content
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "go-tooltip-area",
                                                                            attrs:
                                                                              {
                                                                                "data-toggle":
                                                                                  "tooltip",
                                                                                title:
                                                                                  _vm.isCopied(
                                                                                    indexSentence
                                                                                  )
                                                                                    ? _vm.$t(
                                                                                        "ask.copied"
                                                                                      )
                                                                                    : _vm.$t(
                                                                                        "ask.copy"
                                                                                      ),
                                                                                "data-original-title":
                                                                                  "Copy",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "i",
                                                                              {
                                                                                staticClass:
                                                                                  "go-icon-20 go-icon-copy",
                                                                              }
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        !(
                                                          (!sentence.llmContent ||
                                                            sentence.llmContent
                                                              .length == 0 ||
                                                            !sentence.content) &&
                                                          !sentence.resourceIds
                                                        ) &&
                                                        !_vm.waitingResponse &&
                                                        !sentence.isDeepAnswer
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "go-chat-suggest",
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "go-chat-suggest-area",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "go-chat-alert-msg",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "strong",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "ask.alert.text1"
                                                                                )
                                                                              )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "ul",
                                                                          {
                                                                            staticClass:
                                                                              "go-info-list",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "li",
                                                                              {
                                                                                staticClass:
                                                                                  "go-list-item",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm.$t(
                                                                                      "ask.alert.text2"
                                                                                    )
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "go-chat-alert-btn",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "button",
                                                                          {
                                                                            staticClass:
                                                                              "btn go-btn-default",
                                                                            attrs:
                                                                              {
                                                                                type: "button",
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.resendDeepResearch(
                                                                                    indexSentence
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "em",
                                                                              {
                                                                                staticClass:
                                                                                  "go-text go-primary",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm.$t(
                                                                                      "cdHome.t8"
                                                                                    )
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                )
                              }
                            ),
                            _vm._v(" "),
                            _vm.suggestionList && _vm.suggestionList.length
                              ? _c(
                                  "li",
                                  {
                                    staticClass: "go-chat-item-suggestion sub",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "go-suggestion-list" },
                                      _vm._l(
                                        _vm.suggestionList,
                                        function (suggestSentence) {
                                          return _c(
                                            "div",
                                            {
                                              key: suggestSentence,
                                              staticClass: "go-suggestion-item",
                                            },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "go-suggestion-btn",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.chooseSuggestSentence(
                                                        suggestSentence
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(suggestSentence) +
                                                      "\n                  "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.getSelectedReferenceIds.length
                              ? _c("li", { staticClass: "go-chat-item-info" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "go-chat-date-label",
                                      staticStyle: { "word-break": "keep-all" },
                                    },
                                    [
                                      _c(
                                        "strong",
                                        { staticStyle: { color: "#fd7e15" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "ask.askWithSelectedReference.text1"
                                              )
                                            ) +
                                              " " +
                                              _vm._s(
                                                _vm.getSelectedReferenceIds
                                                  .length
                                              ) +
                                              _vm._s(
                                                _vm.$t(
                                                  "ask.askWithSelectedReference.text2"
                                                )
                                              )
                                          ),
                                        ]
                                      ),
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "ask.askWithSelectedReference.text3"
                                          )
                                        )
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "ask.askWithSelectedReference.text4"
                                          )
                                        ) + "\n              "
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                          ],
                          2
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "go-widget-sub-tab" }, [
                    _c("div", { staticClass: "go-chat-tab" }, [
                      _c("div", { staticClass: "tab-header" }, [
                        _c("ul", { staticClass: "nav go-tab-line" }, [
                          _c("li", { staticClass: "go-tab-item" }, [
                            _c(
                              "a",
                              {
                                staticClass: "go-tab-link active",
                                attrs: {
                                  href: "#",
                                  "data-toggle": "tab",
                                  "data-target": "#go-widget-sub-activity",
                                  "aria-selected": "true",
                                },
                              },
                              [
                                _c("span", { staticClass: "go-text" }, [
                                  _vm._v(_vm._s(_vm.$t("cdHome.t90"))),
                                ]),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("li", { staticClass: "go-tab-item" }, [
                            _c(
                              "a",
                              {
                                staticClass: "go-tab-link",
                                attrs: {
                                  href: "#",
                                  "data-toggle": "tab",
                                  "data-target": "#go-widget-sub-reference",
                                  "aria-selected": "false",
                                },
                              },
                              [
                                _c("span", { staticClass: "go-text" }, [
                                  _vm._v(_vm._s(_vm.$t("cdHome.t91"))),
                                ]),
                              ]
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "tab-content" }, [
                        _c(
                          "div",
                          {
                            staticClass: "tab-pane fade show active",
                            attrs: { id: "go-widget-sub-activity" },
                          },
                          [
                            _c("div", { staticClass: "tab-pane-wrap" }, [
                              _c(
                                "div",
                                { staticClass: "chat-tab-body" },
                                [
                                  _c(
                                    "vue-custom-scrollbar",
                                    {
                                      ref: "answerGenerationProcessData",
                                      staticClass:
                                        "tab-card-list type overflow-y-scroll customScroll csScrollPosition ps",
                                      attrs: {
                                        settings: {
                                          suppressScrollX: true,
                                          wheelPropagation: true,
                                          wheelSpeed: 0.5,
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          ref: "answerGenerationProcessDataWrap",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "create-answer" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "go-elements" },
                                                _vm._l(
                                                  _vm.askActivities,
                                                  function (activity, index) {
                                                    return _c(
                                                      "dl",
                                                      { key: index },
                                                      [
                                                        _c(
                                                          "dt",
                                                          {
                                                            attrs: {
                                                              "data-toggle":
                                                                "collapse",
                                                              "data-target":
                                                                "#go-answer-type-" +
                                                                (index + 1),
                                                              "aria-expanded":
                                                                "false",
                                                            },
                                                          },
                                                          [
                                                            _c("div", [
                                                              _c("em", [
                                                                _c("i", {
                                                                  class: [
                                                                    "go-icon-20",
                                                                    activity.isLoading
                                                                      ? "go-spinner"
                                                                      : "go-icon-check",
                                                                  ],
                                                                }),
                                                              ]),
                                                              _vm._v(" "),
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    activity.content
                                                                  )
                                                                ),
                                                              ]),
                                                            ]),
                                                            _vm._v(" "),
                                                            activity.description
                                                              ? _c("div", [
                                                                  _c("span", {
                                                                    staticClass:
                                                                      "go-toggle-off",
                                                                  }),
                                                                  _vm._v(" "),
                                                                  _c("span", {
                                                                    staticClass:
                                                                      "go-toggle-on",
                                                                  }),
                                                                  _vm._v(" "),
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "go-icon-18 go-icon-chevron-up",
                                                                  }),
                                                                ])
                                                              : _vm._e(),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        activity.description
                                                          ? _c("dd", {
                                                              directives: [
                                                                {
                                                                  name: "markdown",
                                                                  rawName:
                                                                    "v-markdown",
                                                                  value:
                                                                    activity.description,
                                                                  expression:
                                                                    "activity.description",
                                                                },
                                                              ],
                                                              class: [
                                                                "collapse show go-markup",
                                                              ],
                                                              attrs: {
                                                                id:
                                                                  "go-answer-type-" +
                                                                  (index + 1),
                                                              },
                                                            })
                                                          : _vm._e(),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "tab-pane fade",
                            attrs: { id: "go-widget-sub-reference" },
                          },
                          [
                            _c("div", { staticClass: "tab-pane-wrap" }, [
                              _c("div", { staticClass: "chat-tab-head" }, [
                                _vm.checkedReferenceIds.length
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "go-select-info",
                                        staticStyle: {
                                          "justify-content": "left",
                                        },
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn go-btn-icon go-btn-check",
                                            class: {
                                              active:
                                                _vm.getReferenceDocuments
                                                  .length &&
                                                _vm.checkedReferenceIds
                                                  .length &&
                                                _vm.checkedReferenceIds
                                                  .length ===
                                                  _vm.getReferenceDocuments
                                                    .length,
                                            },
                                            attrs: {
                                              id: "switch-check-all-button",
                                              type: "button",
                                              "data-toggle": "button",
                                              "aria-pressed": "false",
                                              disabled: _vm.waitingResponse,
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.handleClickCheckedReference(
                                                  undefined,
                                                  "switchAll"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._m(0),
                                            _vm._v(" "),
                                            _vm._m(1),
                                            _vm._v(" "),
                                            _c(
                                              "b-popover",
                                              {
                                                attrs: {
                                                  target:
                                                    "switch-check-all-button",
                                                  triggers: "hover",
                                                  placement: "top",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                        " +
                                                    _vm._s(
                                                      _vm.getReferenceDocuments
                                                        .length &&
                                                        _vm.checkedReferenceIds
                                                          .length &&
                                                        _vm.checkedReferenceIds
                                                          .length ===
                                                          _vm
                                                            .getReferenceDocuments
                                                            .length
                                                        ? _vm.$t(
                                                            "homeBeta.briefingPart.unCheckAll"
                                                          )
                                                        : _vm.$t(
                                                            "homeBeta.briefingPart.checkAll"
                                                          )
                                                    ) +
                                                    "\n                      "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("p", [
                                          _c(
                                            "strong",
                                            { staticClass: "go-count" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.checkedReferenceIds.length
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$t(
                                                  "homeBeta.briefingPart.selectedDocuments"
                                                )
                                              ) +
                                              "\n                    "
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _vm.checkedReferenceIds.length
                                          ? _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn go-btn-icon go-btn-close",
                                                staticStyle: {
                                                  "margin-left": "7px",
                                                },
                                                attrs: {
                                                  id: "clear-all-button",
                                                  type: "button",
                                                  disabled: _vm.waitingResponse,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handleClickCheckedReference(
                                                      undefined,
                                                      "false"
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._m(2),
                                                _vm._v(" "),
                                                _vm.checkedReferenceIds.length
                                                  ? _c(
                                                      "b-popover",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "show",
                                                            rawName: "v-show",
                                                            value:
                                                              _vm
                                                                .checkedReferenceIds
                                                                .length,
                                                            expression:
                                                              "checkedReferenceIds.length",
                                                          },
                                                        ],
                                                        style: {
                                                          display: _vm
                                                            .checkedReferenceIds
                                                            .length
                                                            ? ""
                                                            : "none",
                                                        },
                                                        attrs: {
                                                          id: "popover-clear-all",
                                                          target:
                                                            "clear-all-button",
                                                          triggers: "hover",
                                                          placement: "top",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "homeBeta.briefingPart.clearAll"
                                                            )
                                                          ) +
                                                            "\n                      "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.checkedReferenceIds ||
                                _vm.checkedReferenceIds.length === 0
                                  ? _c("div", { staticClass: "go-elements" }, [
                                      _c(
                                        "div",
                                        { staticClass: "go-widget-title" },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$t(
                                                  "homeBeta.briefingPart.title"
                                                )
                                              )
                                          ),
                                          _c(
                                            "small",
                                            { staticClass: "go-count" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.referenceDocuments
                                                    .length || 0
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn go-btn-outline-primary",
                                          attrs: {
                                            type: "button",
                                            disabled:
                                              _vm.waitingResponse ||
                                              _vm.getSelectedBriefingPage
                                                .isActive === 0,
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.handleOpenPopupEditReference.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "go-icon-16 go-icon-edit",
                                          }),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "homeBeta.briefingPart.edit"
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "chat-tab-body" },
                                [
                                  _c(
                                    "vue-custom-scrollbar",
                                    {
                                      staticClass:
                                        "tab-card-list overflow-y-scroll customScroll csScrollPosition ps",
                                      attrs: {
                                        settings: {
                                          suppressScrollX: true,
                                          wheelPropagation: true,
                                          wheelSpeed: 0.3,
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "go-card-sub-wrap" },
                                        [
                                          _c(
                                            "ul",
                                            {
                                              staticClass:
                                                "go-card-sub-list go-card-reference2",
                                            },
                                            _vm._l(
                                              _vm.referenceDocuments,
                                              function (document, index) {
                                                return _c(
                                                  "new-reference-card-component",
                                                  {
                                                    key:
                                                      "briefing_reference_card_" +
                                                      index +
                                                      "_" +
                                                      Math.floor(
                                                        Math.random() * 10000
                                                      ),
                                                    attrs: {
                                                      "form-model": document,
                                                      "checked-reference-ids":
                                                        _vm.checkedReferenceIds,
                                                      "is-waiting-response":
                                                        _vm.waitingResponse,
                                                      "style-for":
                                                        _vm.REFERENCE_STYLE_FOR.BRIEFING_REFERENCE.toString(),
                                                      "index-item": index,
                                                      inactive:
                                                        _vm
                                                          .getSelectedBriefingPage
                                                          .isActive === 0,
                                                    },
                                                    on: {
                                                      showDetail:
                                                        _vm.showDetail,
                                                      handleClickCheckedReference:
                                                        _vm.handleClickCheckedReference,
                                                    },
                                                  }
                                                )
                                              }
                                            ),
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "go-sidebar-toggle" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn go-btn-icon",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              _vm.isShowDetailActivity =
                                !_vm.isShowDetailActivity
                            },
                          },
                        },
                        [
                          _vm.isShowDetailActivity
                            ? _c(
                                "span",
                                {
                                  staticClass: "go-tooltip-area go-toggle-on",
                                  attrs: {
                                    "data-toggle": "tooltip",
                                    title: "Minimize",
                                    "data-original-title": "Minimize",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "go-icon-20 go-icon-arrow-autofit-right",
                                  }),
                                ]
                              )
                            : _c(
                                "span",
                                {
                                  staticClass: "go-tooltip-area go-toggle-off",
                                  attrs: {
                                    "data-toggle": "tooltip",
                                    title: "Maximize",
                                    "data-original-title": "Maximize",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "go-icon-20 go-icon-arrow-autofit-width",
                                  }),
                                ]
                              ),
                        ]
                      ),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "go-widget-footer" }, [
                _c("div", { staticClass: "go-chat-wrap" }, [
                  _c(
                    "div",
                    {
                      staticClass: "go-block-header",
                      attrs: { id: "alert-area" },
                    },
                    [_c("alert-deep-research")],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "go-block-body" }, [
                    _c(
                      "div",
                      { staticClass: "go-chat-write-area" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "chat-input-wrap",
                            class: {
                              noInteraction:
                                _vm.waitingResponse && !_vm.hasActivityLoading,
                            },
                            staticStyle: {
                              height: "auto",
                              "min-height": "48px",
                            },
                            attrs: { id: "chatInputWrap_" + _vm.idDetected },
                          },
                          [
                            _c("textarea", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.typingSentence,
                                  expression: "typingSentence",
                                },
                              ],
                              ref: "chatInput",
                              staticStyle: {
                                "overflow-x": "hidden",
                                "overflow-y": "auto",
                              },
                              attrs: {
                                id: "chatInput_" + _vm.idDetected,
                                rows: "1",
                                maxlength: "3000",
                                placeholder: _vm.$t("cdHome.t4"),
                                disabled: _vm.waitingResponse,
                              },
                              domProps: { value: _vm.typingSentence },
                              on: {
                                input: [
                                  function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.typingSentence = $event.target.value
                                  },
                                  function ($event) {
                                    return _vm.resize()
                                  },
                                ],
                                keypress: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  if (
                                    $event.ctrlKey ||
                                    $event.shiftKey ||
                                    $event.altKey ||
                                    $event.metaKey
                                  ) {
                                    return null
                                  }
                                  $event.preventDefault()
                                  return _vm.sendSentence()
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "chat-input-button" }, [
                              _c(
                                "ul",
                                { staticClass: "select-dropdown-wrap" },
                                [
                                  _c("li", { staticClass: "btn-add-drop" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "go-add-reference dropup",
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "btn go-btn-add",
                                            attrs: {
                                              type: "button",
                                              "data-toggle": "dropdown",
                                              "aria-expanded": "false",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleCheckIsGuestAccount(
                                                  $event
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "go-tooltip-area",
                                                attrs: {
                                                  "data-toggle": "tooltip",
                                                  title: _vm.$t("cdHome.t36"),
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "go-icon-18 go-icon-plus",
                                                }),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.referenceDocuments.length
                                              ? _c("em", [
                                                  _vm._v(
                                                    "\n                          " +
                                                      _vm._s(
                                                        _vm.referenceDocuments.filter(
                                                          function (item) {
                                                            return (
                                                              item.isNew !==
                                                                undefined &&
                                                              item.isNew
                                                            )
                                                          }
                                                        ).length
                                                      )
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("li", { staticClass: "btn-select-drop" }, [
                                    !_vm.hideResearchMode
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "go-chat-select dropup",
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                attrs: {
                                                  type: "button",
                                                  "data-toggle": "dropdown",
                                                  "aria-expanded": "false",
                                                },
                                              },
                                              [
                                                _vm.llmType == "none"
                                                  ? _c("em", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.researchType !==
                                                            "quick"
                                                            ? _vm.$t(
                                                                "cdHome.t8"
                                                              )
                                                            : _vm.$t(
                                                                "cdHome.t6"
                                                              )
                                                        )
                                                      ),
                                                    ])
                                                  : _c("em", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.researchType !==
                                                            "quick"
                                                            ? _vm.$t(
                                                                "cdHome.t8"
                                                              )
                                                            : _vm.$t(
                                                                "cdHome.t6"
                                                              )
                                                        ) +
                                                          ",\n                          " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              (
                                                                _vm.llmModels.find(
                                                                  function (
                                                                    item
                                                                  ) {
                                                                    return (
                                                                      item.value ==
                                                                      _vm.llmType
                                                                    )
                                                                  }
                                                                ) || {}
                                                              ).text ||
                                                                "cdHome.t12"
                                                            )
                                                          )
                                                      ),
                                                    ]),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "go-tooltip-area",
                                                    attrs: {
                                                      "data-toggle": "tooltip",
                                                      title:
                                                        _vm.$t("cdHome.t5"),
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "go-icon-16 go-icon-chevron-down",
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "dropdown-menu mode",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "go-nav-select-list",
                                                  },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("cdHome.t5")
                                                        )
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "ul",
                                                      _vm._l(
                                                        _vm.askTypes,
                                                        function (type, index) {
                                                          return _c(
                                                            "li",
                                                            {
                                                              key: index,
                                                              class: [
                                                                _vm.researchType ===
                                                                type.value
                                                                  ? "active"
                                                                  : "",
                                                              ],
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.preventDefault()
                                                                    return _vm.clickToReSearchType(
                                                                      type,
                                                                      $event
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "custom-control custom-radio",
                                                                },
                                                                [
                                                                  _c("input", {
                                                                    staticClass:
                                                                      "custom-control-input",
                                                                    attrs: {
                                                                      type: "radio",
                                                                      name: "go-askgoover-researchMode",
                                                                      id: "researchCheck1",
                                                                    },
                                                                    domProps: {
                                                                      checked:
                                                                        _vm.researchType ==
                                                                        type.value,
                                                                    },
                                                                  }),
                                                                  _vm._v(" "),
                                                                  _c("label", {
                                                                    staticClass:
                                                                      "custom-control-label",
                                                                    attrs: {
                                                                      for: "researchCheck1",
                                                                    },
                                                                  }),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("p", [
                                                                _c("strong", [
                                                                  _c("em", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          type.text
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c("small", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "ask.with"
                                                                        )
                                                                      ) +
                                                                        " " +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "cdHome.t12"
                                                                          )
                                                                        )
                                                                    ),
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  type.plan
                                                                    ? _c(
                                                                        "i",
                                                                        {
                                                                          staticClass:
                                                                            "badge_paid",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                type.plan
                                                                              )
                                                                            )
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                ]),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "go-tooltip-area",
                                                                    attrs: {
                                                                      "data-toggle":
                                                                        "tooltip",
                                                                      title:
                                                                        _vm.$t(
                                                                          type.description
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          type.description
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "go-nav-select-list",
                                                  },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("cdHome.t11")
                                                        )
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "ul",
                                                      _vm._l(
                                                        _vm.llmModels.filter(
                                                          function (item) {
                                                            return (
                                                              item.value !==
                                                              "dall_e_3"
                                                            )
                                                          }
                                                        ),
                                                        function (llm, index) {
                                                          return _c(
                                                            "li",
                                                            {
                                                              key: index,
                                                              class: [
                                                                _vm.llmType ===
                                                                llm.value
                                                                  ? "active"
                                                                  : "",
                                                              ],
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.preventDefault()
                                                                    return function () {
                                                                      return _vm.changeLlmType(
                                                                        llm,
                                                                        $event
                                                                      )
                                                                    }.apply(
                                                                      null,
                                                                      arguments
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "custom-control custom-radio",
                                                                },
                                                                [
                                                                  _c("input", {
                                                                    staticClass:
                                                                      "custom-control-input",
                                                                    attrs: {
                                                                      type: "radio",
                                                                      name: "go-askgoover-llmModel",
                                                                      id: "modelCheck1",
                                                                    },
                                                                    domProps: {
                                                                      checked:
                                                                        _vm.llmType ===
                                                                        llm.value,
                                                                    },
                                                                  }),
                                                                  _vm._v(" "),
                                                                  _c("label", {
                                                                    staticClass:
                                                                      "custom-control-label",
                                                                    attrs: {
                                                                      for: "modelCheck1",
                                                                    },
                                                                  }),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("p", [
                                                                _c("strong", [
                                                                  _c("em", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          llm.text
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  llm.plan
                                                                    ? _c(
                                                                        "i",
                                                                        {
                                                                          staticClass:
                                                                            "badge_paid",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                llm.plan
                                                                              )
                                                                            )
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                ]),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "go-tooltip-area",
                                                                    attrs: {
                                                                      "data-toggle":
                                                                        "tooltip",
                                                                      title:
                                                                        _vm.$t(
                                                                          llm.description
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          llm.description
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.hideDatasourceOption
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "go-chat-select dropup",
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                attrs: {
                                                  type: "button",
                                                  "data-toggle": "dropdown",
                                                  "aria-expanded": "false",
                                                },
                                              },
                                              [
                                                _c(
                                                  "em",
                                                  {
                                                    staticClass:
                                                      "go-tooltip-area",
                                                    attrs: {
                                                      "data-toggle": "tooltip",
                                                      title: _vm.tooltipContent,
                                                    },
                                                  },
                                                  [
                                                    _vm._l(
                                                      _vm.indexName.slice(0, 3),
                                                      function (item, index) {
                                                        return _c(
                                                          "span",
                                                          { key: index },
                                                          [
                                                            _vm._v(
                                                              "\n                            " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    (
                                                                      _vm.dataSources.find(
                                                                        function (
                                                                          dt
                                                                        ) {
                                                                          return (
                                                                            dt.value ==
                                                                            item
                                                                          )
                                                                        }
                                                                      ) || {}
                                                                    ).text
                                                                  ) ||
                                                                    _vm.$t(
                                                                      "cdHome.t19"
                                                                    )
                                                                )
                                                            ),
                                                            index <
                                                            _vm.indexName
                                                              .length -
                                                              1
                                                              ? _c("span", [
                                                                  _vm._v(", "),
                                                                ])
                                                              : _vm._e(),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.indexName.length > 3
                                                      ? _c("span", [
                                                          _vm._v(
                                                            " +" +
                                                              _vm._s(
                                                                _vm.indexName
                                                                  .length - 3
                                                              )
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    !_vm.indexName ||
                                                    _vm.indexName.length === 0
                                                      ? _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "cdHome.t18"
                                                              )
                                                            )
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                  ],
                                                  2
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "go-tooltip-area",
                                                    attrs: {
                                                      "data-toggle": "tooltip",
                                                      title:
                                                        _vm.$t("cdHome.t18"),
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "go-icon-16 go-icon-chevron-down",
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "dropdown-menu data-source",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "go-nav-select-list more-content",
                                                  },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("cdHome.t18")
                                                        )
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "ul",
                                                      _vm._l(
                                                        _vm.dataSources,
                                                        function (
                                                          dataSource,
                                                          index
                                                        ) {
                                                          return _c(
                                                            "li",
                                                            {
                                                              key: index,
                                                              class: [
                                                                _vm.indexName.includes(
                                                                  dataSource.value
                                                                )
                                                                  ? "active"
                                                                  : "",
                                                              ],
                                                              staticStyle: {
                                                                "justify-content":
                                                                  "normal !important",
                                                              },
                                                              on: {
                                                                click: [
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.putOrRemoveIndexName(
                                                                      dataSource,
                                                                      $event
                                                                    )
                                                                  },
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.preventDefault()
                                                                  },
                                                                ],
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "custom-control custom-checkbox",
                                                                },
                                                                [
                                                                  _c("input", {
                                                                    staticClass:
                                                                      "custom-control-input noEvent",
                                                                    attrs: {
                                                                      type: "checkbox",
                                                                      id: "sourceCheck1",
                                                                    },
                                                                    domProps: {
                                                                      checked:
                                                                        dataSource.value ===
                                                                          "BASIC" ||
                                                                        _vm.indexName.includes(
                                                                          dataSource.value
                                                                        ),
                                                                    },
                                                                  }),
                                                                  _vm._v(" "),
                                                                  _c("label", {
                                                                    staticClass:
                                                                      "custom-control-label",
                                                                    attrs: {
                                                                      for: "sourceCheck1",
                                                                    },
                                                                  }),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("p", [
                                                                _c("strong", [
                                                                  _c("em", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          dataSource.text
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  dataSource.plan &&
                                                                  !_vm.isPaidUser(
                                                                    true
                                                                  )
                                                                    ? _c(
                                                                        "i",
                                                                        {
                                                                          staticClass:
                                                                            "badge_paid",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                dataSource.plan
                                                                              )
                                                                            )
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                ]),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "go-tooltip-area",
                                                                    attrs: {
                                                                      "data-toggle":
                                                                        "tooltip",
                                                                      title:
                                                                        _vm.$t(
                                                                          dataSource.description
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                                  " +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            dataSource.description
                                                                          )
                                                                        ) +
                                                                        "\n                                "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c("ul", { staticClass: "history-chat-wrap" }, [
                                _c("li", [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn go-btn-chat-sand",
                                      attrs: {
                                        type: "button",
                                        disabled:
                                          _vm.waitingResponse ||
                                          !_vm.typingSentence.trim().length,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.sendSentence()
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "go-icon-18 go-icon-send",
                                      }),
                                    ]
                                  ),
                                ]),
                              ]),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.page === _vm.PAGES.HOME ||
                        this.$route.name === "MyBriefing-Detail" ||
                        _vm.page === _vm.PAGES.MY_CREATE
                          ? [
                              _c(
                                "div",
                                {
                                  staticClass: "go-over-btn",
                                  class: {
                                    noInteraction:
                                      _vm.waitingResponse ||
                                      !_vm.referenceDocuments ||
                                      _vm.referenceDocuments.length === 0 ||
                                      (this.$route.name ===
                                        "MyBriefing-Detail" &&
                                        !_vm.getIsAllowGoOverAgain),
                                  },
                                  staticStyle: { "max-width": "72px" },
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      attrs: {
                                        disabled:
                                          _vm.waitingResponse ||
                                          !_vm.referenceDocuments ||
                                          _vm.referenceDocuments.length === 0 ||
                                          (this.$route.name ===
                                            "MyBriefing-Detail" &&
                                            !_vm.getIsAllowGoOverAgain),
                                      },
                                      on: { click: _vm.openModal },
                                    },
                                    [
                                      _vm._m(3),
                                      _vm._v(" "),
                                      _c(
                                        "em",
                                        [
                                          _vm._v(
                                            "\n                    GO OVER\n                    "
                                          ),
                                          this.page === _vm.PAGES.BRIEFING
                                            ? [_vm._v("AGAIN")]
                                            : _vm._e(),
                                        ],
                                        2
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("popup-select-type-reference", {
            attrs: { open: _vm.openSelectTypeReference },
            on: {
              close: function ($event) {
                _vm.openSelectTypeReference = false
              },
              "select-reference-type":
                _vm.handleOpenPopupAddReferenceBySelectedReferenceTab,
            },
          }),
        ],
        1
      )
    : _c(
        "div",
        { class: ["go-widget go-widget-side go-widget-ask"] },
        [
          _c("div", { staticClass: "go-widget-body" }, [
            _c(
              "div",
              { staticClass: "go-list-wrap" },
              [
                _c(
                  "vue-custom-scrollbar",
                  {
                    ref: "go-list-inner",
                    staticClass: "go-list-inner overflow-y-scroll",
                    staticStyle: { "padding-right": "10px", height: "100%" },
                    attrs: {
                      id: "go-list-inner-chat",
                      settings: {
                        suppressScrollX: true,
                        wheelPropagation: true,
                        wheelSpeed: 0.5,
                      },
                    },
                  },
                  [
                    _c(
                      "ul",
                      { ref: "go-chat-list", staticClass: "go-chat-list" },
                      [
                        _vm._l(
                          _vm.conversation.sentences,
                          function (sentence, indexSentence) {
                            return _c(
                              "li",
                              {
                                key: indexSentence,
                                staticClass: "go-chat-item-message",
                              },
                              [
                                sentence.role === _vm.CONVERSATION_ROLE.USER
                                  ? _c(
                                      "div",
                                      { staticClass: "go-user-message" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "go-user-thumb" },
                                          [
                                            _c("img", {
                                              attrs: {
                                                src: _vm.tempCurrentUserImageUri,
                                                alt: "User Image",
                                              },
                                            }),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "go-chat-message-area",
                                            style:
                                              _vm.page ===
                                              _vm.PAGES.COMPANY_BRIEFING
                                                ? { marginLeft: "8px" }
                                                : {},
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "go-chat-message-balloon",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "go-block-body",
                                                  },
                                                  [
                                                    _c("p", {
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          sentence.content
                                                        ),
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : sentence.role !== _vm.CONVERSATION_ROLE.DATE
                                  ? _c(
                                      "div",
                                      { staticClass: "go-response-message" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "go-chat-message-area",
                                          },
                                          [
                                            (!sentence.llmContent ||
                                              sentence.llmContent.length == 0 ||
                                              !sentence.content) &&
                                            !sentence.resourceIds
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "go-chat-message-balloon",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "go-chat-message-alert",
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "go-icon-24 go-icon-alert-circle",
                                                        }),
                                                        _vm._v(" "),
                                                        _c("p", {
                                                          domProps: {
                                                            textContent: _vm._s(
                                                              _vm.$t(
                                                                "ask.errorAnswer"
                                                              )
                                                            ),
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "btn go-btn-default go-btn-sm",
                                                            attrs: {
                                                              type: "button",
                                                            },
                                                            on: {
                                                              click:
                                                                _vm.reloadAskAction,
                                                            },
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "go-icon-18 go-icon-reload",
                                                            }),
                                                            _vm._v(
                                                              "\n                      " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "ask.reloadAnswer"
                                                                  )
                                                                ) +
                                                                "\n                    "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            sentence.llmContent &&
                                            sentence.llmContent.length > 0
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "go-chat-message-balloon",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "go-block-body",
                                                        attrs: {
                                                          id:
                                                            "go-block-body_" +
                                                            indexSentence,
                                                        },
                                                      },
                                                      [
                                                        _vm._l(
                                                          sentence.llmContent,
                                                          function (
                                                            item,
                                                            index
                                                          ) {
                                                            return [
                                                              item.model
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      key: index,
                                                                      class: [
                                                                        item.model ==
                                                                        "goover"
                                                                          ? "llm-model-goover"
                                                                          : "llm-model-etc",
                                                                      ],
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "strong",
                                                                        {
                                                                          staticClass:
                                                                            "llm-model-title",
                                                                          staticStyle:
                                                                            {
                                                                              margin:
                                                                                "0 0 1rem 0",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              item.model
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              _c("div", {
                                                                key:
                                                                  "c_" + index,
                                                                staticClass:
                                                                  "go-markdown-body",
                                                                attrs: {
                                                                  id:
                                                                    item.model ==
                                                                    "goover"
                                                                      ? "content_" +
                                                                        indexSentence
                                                                      : "",
                                                                },
                                                                domProps: {
                                                                  innerHTML:
                                                                    _vm._s(
                                                                      _vm.convertMarkdown2Html(
                                                                        item.content
                                                                      )
                                                                    ),
                                                                },
                                                              }),
                                                            ]
                                                          }
                                                        ),
                                                        _vm._v(" "),
                                                        !_vm.waitingResponse &&
                                                        _vm.popoverDataList
                                                          ? _vm._l(
                                                              _vm.popoverDataList,
                                                              function (
                                                                popoverItem
                                                              ) {
                                                                return _c(
                                                                  "b-popover",
                                                                  {
                                                                    key: "bp-".concat(
                                                                      popoverItem.idElement
                                                                    ),
                                                                    attrs: {
                                                                      "custom-class":
                                                                        "go-popover-preview-doc",
                                                                      target:
                                                                        popoverItem.idElement,
                                                                      triggers:
                                                                        "hover",
                                                                      placement:
                                                                        "top",
                                                                    },
                                                                    scopedSlots:
                                                                      _vm._u(
                                                                        [
                                                                          popoverItem.description
                                                                            ? {
                                                                                key: "title",
                                                                                fn: function () {
                                                                                  return [
                                                                                    _c(
                                                                                      "div",
                                                                                      {
                                                                                        staticClass:
                                                                                          "go-preview-info",
                                                                                      },
                                                                                      [
                                                                                        popoverItem.channel
                                                                                          ? _c(
                                                                                              "span",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "go-channel",
                                                                                              },
                                                                                              [
                                                                                                _vm._v(
                                                                                                  _vm._s(
                                                                                                    popoverItem.channel
                                                                                                  )
                                                                                                ),
                                                                                              ]
                                                                                            )
                                                                                          : _vm._e(),
                                                                                        _vm._v(
                                                                                          " "
                                                                                        ),
                                                                                        popoverItem.published_at
                                                                                          ? _c(
                                                                                              "span",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "go-datetime",
                                                                                              },
                                                                                              [
                                                                                                _vm._v(
                                                                                                  _vm._s(
                                                                                                    popoverItem.published_at
                                                                                                  )
                                                                                                ),
                                                                                              ]
                                                                                            )
                                                                                          : _vm._e(),
                                                                                      ]
                                                                                    ),
                                                                                    _vm._v(
                                                                                      " "
                                                                                    ),
                                                                                    _c(
                                                                                      "div",
                                                                                      {
                                                                                        staticClass:
                                                                                          "go-preview-title",
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            popoverItem.title
                                                                                          )
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ]
                                                                                },
                                                                                proxy: true,
                                                                              }
                                                                            : null,
                                                                        ],
                                                                        null,
                                                                        true
                                                                      ),
                                                                  },
                                                                  [
                                                                    _vm._v(" "),
                                                                    popoverItem.description
                                                                      ? [
                                                                          _c(
                                                                            "p",
                                                                            {
                                                                              staticClass:
                                                                                "go-preview-desc",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  popoverItem.description
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      : [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "go-preview-empy",
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "i",
                                                                                {
                                                                                  staticClass:
                                                                                    "go-icon-32 go-icon-hidden",
                                                                                }
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "p",
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      _vm.$t(
                                                                                        "briefing.view-card.preview-empty.text1"
                                                                                      )
                                                                                    )
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "small",
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      _vm.$t(
                                                                                        "briefing.view-card.preview-empty.text2"
                                                                                      )
                                                                                    )
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ],
                                                                  ],
                                                                  2
                                                                )
                                                              }
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      2
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "go-block-footer",
                                                      },
                                                      [
                                                        !(
                                                          (!sentence.llmContent ||
                                                            sentence.llmContent
                                                              .length == 0 ||
                                                            !sentence.content) &&
                                                          !sentence.resourceIds
                                                        ) &&
                                                        !_vm.waitingResponse
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "go-chat-message-btns",
                                                              },
                                                              [
                                                                _c(
                                                                  "button",
                                                                  {
                                                                    key: "go-btn-like"
                                                                      .concat(
                                                                        _vm.buttonLikeOrDisLikeKey ||
                                                                          ""
                                                                      )
                                                                      .concat(
                                                                        "_" +
                                                                          indexSentence
                                                                      ),
                                                                    staticClass:
                                                                      "btn go-btn-icon",
                                                                    class: [
                                                                      "btn go-btn-icon go-btn-like ",
                                                                      {
                                                                        active:
                                                                          sentence.like ===
                                                                          1,
                                                                      },
                                                                    ],
                                                                    attrs: {
                                                                      type: "button",
                                                                      "data-toggle":
                                                                        "button",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.handleUserInteract(
                                                                            sentence,
                                                                            1,
                                                                            indexSentence,
                                                                            $event
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        directives:
                                                                          [
                                                                            {
                                                                              name: "b-tooltip",
                                                                              rawName:
                                                                                "v-b-tooltip.hover",
                                                                              value:
                                                                                {
                                                                                  customClass:
                                                                                    "go-tooltip",
                                                                                },
                                                                              expression:
                                                                                "{ customClass: 'go-tooltip' }",
                                                                              modifiers:
                                                                                {
                                                                                  hover: true,
                                                                                },
                                                                            },
                                                                          ],
                                                                        staticClass:
                                                                          "go-tooltip-area",
                                                                        attrs: {
                                                                          "data-toggle":
                                                                            "tooltip",
                                                                          "data-original-title":
                                                                            "Like",
                                                                          title:
                                                                            _vm.$t(
                                                                              "ask.like"
                                                                            ),
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "i",
                                                                          {
                                                                            staticClass:
                                                                              "go-icon-20 go-icon-like",
                                                                          }
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "button",
                                                                  {
                                                                    key: "go-btn-dislike"
                                                                      .concat(
                                                                        _vm.buttonLikeOrDisLikeKey ||
                                                                          ""
                                                                      )
                                                                      .concat(
                                                                        "_" +
                                                                          indexSentence
                                                                      ),
                                                                    staticClass:
                                                                      "btn go-btn-icon",
                                                                    class: [
                                                                      "btn go-btn-icon go-btn-dislike ",
                                                                      {
                                                                        active:
                                                                          sentence.like ===
                                                                          -1,
                                                                      },
                                                                    ],
                                                                    attrs: {
                                                                      type: "button",
                                                                      "data-toggle":
                                                                        "button",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.handleUserInteract(
                                                                            sentence,
                                                                            -1,
                                                                            indexSentence,
                                                                            $event
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        directives:
                                                                          [
                                                                            {
                                                                              name: "b-tooltip",
                                                                              rawName:
                                                                                "v-b-tooltip.hover",
                                                                              value:
                                                                                {
                                                                                  customClass:
                                                                                    "go-tooltip",
                                                                                },
                                                                              expression:
                                                                                "{ customClass: 'go-tooltip' }",
                                                                              modifiers:
                                                                                {
                                                                                  hover: true,
                                                                                },
                                                                            },
                                                                          ],
                                                                        staticClass:
                                                                          "go-tooltip-area",
                                                                        attrs: {
                                                                          "data-toggle":
                                                                            "tooltip",
                                                                          title:
                                                                            _vm.$t(
                                                                              "ask.dislike"
                                                                            ),
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "i",
                                                                          {
                                                                            staticClass:
                                                                              "go-icon-20 go-icon-dislike",
                                                                          }
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "button",
                                                                  {
                                                                    staticClass:
                                                                      "btn go-btn-icon",
                                                                    attrs: {
                                                                      type: "button",
                                                                      disabled:
                                                                        _vm.isCopied(
                                                                          indexSentence
                                                                        ),
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.copyText(
                                                                            indexSentence,
                                                                            sentence.content
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "go-tooltip-area",
                                                                        attrs: {
                                                                          "data-toggle":
                                                                            "tooltip",
                                                                          title:
                                                                            _vm.isCopied(
                                                                              indexSentence
                                                                            )
                                                                              ? _vm.$t(
                                                                                  "ask.copied"
                                                                                )
                                                                              : _vm.$t(
                                                                                  "ask.copy"
                                                                                ),
                                                                          "data-original-title":
                                                                            "Copy",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "i",
                                                                          {
                                                                            staticClass:
                                                                              "go-icon-20 go-icon-copy",
                                                                          }
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            )
                          }
                        ),
                        _vm._v(" "),
                        _vm.suggestionList && _vm.suggestionList.length
                          ? _c(
                              "li",
                              { staticClass: "go-chat-item-suggestion sub" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "go-suggestion-list" },
                                  _vm._l(
                                    _vm.suggestionList,
                                    function (suggestSentence) {
                                      return _c(
                                        "div",
                                        {
                                          key: suggestSentence,
                                          staticClass: "go-suggestion-item",
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass: "go-suggestion-btn",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.chooseSuggestSentence(
                                                    suggestSentence
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(suggestSentence) +
                                                  "\n                "
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.getSelectedReferenceIds.length
                          ? _c("li", { staticClass: "go-chat-item-info" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "go-chat-date-label",
                                  staticStyle: { "word-break": "keep-all" },
                                },
                                [
                                  _c(
                                    "strong",
                                    { staticStyle: { color: "#fd7e15" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "ask.askWithSelectedReference.text1"
                                          )
                                        ) +
                                          " " +
                                          _vm._s(
                                            _vm.getSelectedReferenceIds.length
                                          ) +
                                          _vm._s(
                                            _vm.$t(
                                              "ask.askWithSelectedReference.text2"
                                            )
                                          )
                                      ),
                                    ]
                                  ),
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "ask.askWithSelectedReference.text3"
                                      )
                                    )
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "ask.askWithSelectedReference.text4"
                                      )
                                    ) + "\n            "
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "go-widget-footer" }, [
            _c("div", { staticClass: "go-chat-wrap" }, [
              _c(
                "div",
                { staticClass: "go-block-header", attrs: { id: "alert-area" } },
                [_c("alert-deep-research")],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "go-block-body" }, [
                _c("div", { staticClass: "go-chat-write-area" }, [
                  _c(
                    "div",
                    {
                      staticClass: "chat-input-wrap",
                      class: {
                        noInteraction:
                          _vm.waitingResponse && !_vm.hasActivityLoading,
                      },
                      staticStyle: { height: "auto", "min-height": "48px" },
                      attrs: { id: "chatInputWrap_" + _vm.idDetected },
                    },
                    [
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.typingSentence,
                            expression: "typingSentence",
                          },
                        ],
                        ref: "chatInput",
                        staticStyle: {
                          "overflow-x": "hidden",
                          "overflow-y": "auto",
                        },
                        attrs: {
                          id: "chatInput_" + _vm.idDetected,
                          rows: "1",
                          maxlength: "3000",
                          placeholder: _vm.$t("cdHome.t4"),
                          disabled: _vm.waitingResponse,
                        },
                        domProps: { value: _vm.typingSentence },
                        on: {
                          input: [
                            function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.typingSentence = $event.target.value
                            },
                            function ($event) {
                              return _vm.resize()
                            },
                          ],
                          keypress: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            if (
                              $event.ctrlKey ||
                              $event.shiftKey ||
                              $event.altKey ||
                              $event.metaKey
                            ) {
                              return null
                            }
                            $event.preventDefault()
                            return _vm.sendSentence()
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "chat-input-button" }, [
                        _c("ul", { staticClass: "select-dropdown-wrap" }, [
                          _c("li", { staticClass: "btn-select-drop" }, [
                            _c(
                              "div",
                              { staticClass: "go-chat-select dropup" },
                              [
                                _c(
                                  "button",
                                  {
                                    attrs: {
                                      type: "button",
                                      "data-toggle": "dropdown",
                                      "aria-expanded": "false",
                                    },
                                  },
                                  [
                                    _c("em", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            (
                                              _vm.llmModels.find(function (
                                                item
                                              ) {
                                                return item.value == _vm.llmType
                                              }) || {}
                                            ).text || "cdHome.t12"
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "go-tooltip-area",
                                        attrs: {
                                          "data-toggle": "tooltip",
                                          title: _vm.$t("cdHome.t11"),
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "go-icon-16 go-icon-chevron-down",
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "dropdown-menu model" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "go-nav-select-list" },
                                      [
                                        _c("b", [
                                          _vm._v(_vm._s(_vm.$t("cdHome.t11"))),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "ul",
                                          _vm._l(
                                            _vm.llmModels,
                                            function (llm, index) {
                                              return _c(
                                                "li",
                                                {
                                                  key: index,
                                                  class: [
                                                    _vm.llmType === llm.value
                                                      ? "active"
                                                      : "",
                                                  ],
                                                  staticStyle: {
                                                    "justify-content":
                                                      "space-between",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      return function () {
                                                        return _vm.changeLlmType(
                                                          llm,
                                                          $event
                                                        )
                                                      }.apply(null, arguments)
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("p", [
                                                    _c("strong", [
                                                      _c("em", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(llm.text)
                                                          )
                                                        ),
                                                      ]),
                                                      _vm._v(" "),
                                                      llm.plan
                                                        ? _c(
                                                            "i",
                                                            {
                                                              staticClass:
                                                                "badge_paid",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    llm.plan
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "go-tooltip-area",
                                                        attrs: {
                                                          "data-toggle":
                                                            "tooltip",
                                                          title: _vm.$t(
                                                            llm.description
                                                          ),
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              llm.description
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "custom-control custom-checkbox",
                                                    },
                                                    [
                                                      _c("input", {
                                                        staticClass:
                                                          "custom-control-input",
                                                        attrs: {
                                                          type: "checkbox",
                                                          id: "modelCheck2",
                                                        },
                                                        domProps: {
                                                          checked:
                                                            _vm.llmType ===
                                                            llm.value,
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("label", {
                                                        staticClass:
                                                          "custom-control-label",
                                                        attrs: {
                                                          for: "modelCheck2",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("ul", { staticClass: "history-chat-wrap" }, [
                          _c("li", [
                            _c(
                              "button",
                              {
                                staticClass: "btn go-btn-chat-sand",
                                attrs: {
                                  type: "button",
                                  disabled:
                                    _vm.waitingResponse ||
                                    !_vm.typingSentence.trim().length,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.sendSentence()
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "go-icon-18 go-icon-send",
                                }),
                              ]
                            ),
                          ]),
                        ]),
                      ]),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("popup-select-type-reference", {
            attrs: { open: _vm.openSelectTypeReference },
            on: {
              close: function ($event) {
                _vm.openSelectTypeReference = false
              },
              "select-reference-type":
                _vm.handleOpenPopupAddReferenceBySelectedReferenceTab,
            },
          }),
        ],
        1
      )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "go-tooltip-area go-toggle-off" }, [
      _c("i", { staticClass: "go-icon-18 go-icon-check" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "go-tooltip-area go-toggle-on" }, [
      _c("i", { staticClass: "go-icon-18 go-icon-check" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "go-tooltip-area go-toggle-off" }, [
      _c("i", { staticClass: "go-icon-18 go-icon-close" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("i", { staticClass: "go-icon-14 go-icon-goover-white" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }